<script setup>
    import { useHead } from "#imports";

    useHead({
        script: [
            {
                id: "retail-crm-script",
                innerHTML: `
                  var _rcct = "4dfd5b7d6bc9f10cebcf3cdeb03183408b5ce538be90f54c2251ec5753e30c39";
                  !function (t) {
                    var a = t.getElementsByTagName("head")[0];
                    var c = t.createElement("script");
                    c.type = "text/javascript";
                    c.src = "//c.retailcrm.tech/widget/loader.js";
                    a.appendChild(c);
                  }(document);
                `,
                type: "text/javascript"
            }
        ]
    });
</script>

<template>
  <NuxtLayout>
    <div>
      <NuxtLoadingIndicator />
      <!-- <LoaderOverlay /> -->
      <NuxtPage />
    </div>
  </NuxtLayout>
</template>